import clsx from 'clsx';
import type { HTMLAttributes, ReactNode, ForwardRefRenderFunction } from 'react';
import { forwardRef } from 'react';

import BayTooltip from '../../../BayTooltip';
import type { MenuItem as MenuItemType } from '../../../types/dashboard';

interface MenuItemProps extends Omit<HTMLAttributes<HTMLLIElement>, 'prefix'> {
	children?: ReactNode;
	className?: string;
	icon?: ReactNode;
	accessDenied?: boolean;
	active?: boolean;
	prefix?: ReactNode;
	suffix?: ReactNode;
	firstchild?: boolean;
	popperarrow?: boolean;
	menuItem?: MenuItemType & {
		isAccessDenied?: boolean;
		toolTip?: string;
		title?: string;
	};
	collapsed?: boolean;
}

const MenuItem: ForwardRefRenderFunction<HTMLLIElement, MenuItemProps> = (
	{
		children,
		className,
		icon,
		accessDenied,
		active,
		prefix,
		suffix,
		firstchild,
		popperarrow,
		menuItem,
		collapsed,
		...rest
	},
	ref,
) => {
	return (
		<li
			ref={ref}
			className={clsx('bay-sidenav-menu-item', className, { active })}
			{...rest}
		>
			<BayTooltip
				disabled={!accessDenied}
				overlay={
					<span>
						{menuItem?.isAccessDenied
							? menuItem?.toolTip ? menuItem?.toolTip : 'This feature has been disabled. Please contact your system administrator for more information.'
							: menuItem?.title}
					</span>
				}
				placement="right"
			>
				{collapsed ? (
					<div
						className="bay-sidenav-inner-item"
						role="button"
						style={accessDenied ? { cursor: 'default' } : {}}
						tabIndex={0}
					>
						{icon ? (
							<span className="bay-sidenav-icon-wrapper mx-2">
								<span className="bay-sidenav-icon">{icon}</span>
							</span>
						) : null}

						{prefix ? <span className="prefix-wrapper">{prefix}</span> : null}
						<span className="bay-sidenav-item-content ps-1">{children}</span>
						{suffix ? <span className="suffix-wrapper">{suffix}</span> : null}
					</div>
				) : (
					<div
						className="bay-sidenav-inner-item"
						role="button"
						style={accessDenied ? { cursor: 'default' } : {}}
						tabIndex={0}
					>
						{icon ? (
							<span className="bay-sidenav-icon-wrapper mx-2">
								<span className="bay-sidenav-icon">{icon}</span>
							</span>
						) : null}

						{prefix ? <span className="prefix-wrapper">{prefix}</span> : null}
						<span className="bay-sidenav-item-content ps-1">{children}</span>
						{suffix ? <span className="suffix-wrapper">{suffix}</span> : null}
					</div>
				)}
			</BayTooltip>
		</li>
	);
};

export default forwardRef(MenuItem);
